<div class="form-body">
  <div class="row">
    <div class="img-holder" style="width: 100%;">
      <div class="bg" [ngStyle]="{'background-image': 'url(assets/images/img' + fondo + '.jpg)'}"></div>
      <div class="info-holder">
      </div>
    </div>
    <div class="form-holder" style="z-index: 999;">
      <div id="frmLogin" class="form-content" *ngIf="secMostrar !== 'ACTUALIZAR'">
        <div class="form-items" [ngClass]="{'hide-it': secMostrar !== 'INGRESO', 'show-it': secMostrar === 'INGRESO' }"
             style="text-align: center;
              border: 1px solid #fff;
              padding: 35px 35px 14px;
              border-radius: 20px;
              background-color: #ffffffd9;
              height: auto;
              box-shadow: 0px 0px 10px 2px #969696;">
          <div *ngIf="secMostrar === 'INGRESO'">
            <div>
              <img class="logo-size" src="assets/images/logo-analizamos-color-completo.svg" alt=""
                   style="margin-bottom: 34px;">
            </div>
            <form name="forAutenticacion" (ngSubmit)="f.valid && ingresar()" #f="ngForm" novalidate
                  style="margin-bottom: 0;">
              <div *ngIf="!carGoogle">
                <input type="text" [(ngModel)]="usuario" autocomplete="off" sinEspacios
                       [minuscula]="true" [sinCaracteres]="true"
                       placeholder="* {{ 'AUTENTICACION.LBL_USUARIO' | translate }}" [required]="true"
                       name="nomUsuario" id="idUsuario" #NGusuario="ngModel"
                       style="box-shadow: 0px 2px 3px 2px #c2c2c2;">
                <p *ngIf="f.submitted && !NGusuario.valid"
                   class="texto-rojo">{{ 'AUTENTICACION.LBL_USUARIO' | translate }}
                  {{'LBL_REQUERIDO' | translate }}</p>
                <input type="password" [(ngModel)]="contrasena" autocomplete="off"
                       placeholder="* {{ 'AUTENTICACION.LBL_CONTRASENA' | translate }}"
                       name="nomContrasena" id="idContrasena" required="true" #NGcontrasena="ngModel"
                       style="margin-bottom: 0px; box-shadow: 0px 2px 3px 2px #c2c2c2;">
                <p *ngIf="f.submitted && !NGcontrasena.valid"
                   class="texto-rojo">{{ 'AUTENTICACION.LBL_CONTRASENA' | translate }}
                  {{'LBL_REQUERIDO' | translate}}</p>
                <p *ngIf="error" class="texto-rojo">{{error}}</p>
                <div class="form-button">
                  <div *ngIf="!carIngreso">
                    <button id="btnIngresar" type="submit"
                            class="ibtn btn-block">{{ 'BTN_INGRESAR' | translate }}</button>
                    <br>
                    <a (click)="olvidoContrasena(f)"
                       style="color: #333333;">{{ 'AUTENTICACION.LBL_OLVIDOCONTRASENA' | translate }}</a>
                  </div>
                  <div *ngIf="carIngreso" class="text-general" style="color:green!important;">
                    <i class="fa fa-refresh fa-spin fa-2x fa-fw"></i><br>
                    <span>{{ 'LBL_PROCESANDO' | translate}}</span>
                  </div>
                </div>
                <div class="other-links flex justify-content-center logo-google" *ngIf="verGoogle">

                  <!-- <div class="google-btn" (click)="ingresarRedes('GOOGLE')">
                    <div class="google-icon-wrapper">
                      <img class="google-icon" src="assets/images/logo_G_google.svg" alt=""/>
                    </div>
                    <p class="btn-text"><b>{{ 'AUTENTICACION.LBL_INICIARSESIONGOOGLE' | translate }}</b></p>
                  </div> -->
                  <asl-google-signin-button type='standard' size='large' width="300">
                  </asl-google-signin-button>
                </div>

              </div>
              <div *ngIf="carGoogle" class="text-center">
                <i class="fa fa-refresh fa-spin fa-2x fa-fw"></i><br>
                <span>{{ 'LBL_PROCESANDO' | translate }}...</span>
              </div>
              <div id="version-app">
                <strong>v {{ 'LBL_VERSIONSISTEMA' | translate}}</strong>
              </div>
              <div class="text-center">
                <i class="fa fa-eraser" id="iconoRefreshCache" title="Recargar cache" onClick="forceReloadAssets()"></i>
              </div>
            </form>
          </div>
        </div>
        <div class="form-sent"
             [ngClass]="{'hide-it': secMostrar !== 'RECUPERAR', 'show-it': secMostrar === 'RECUPERAR' }"
             style="border: 1px solid #fff;
             padding: 35px 35px 14px;
             border-radius: 20px;
             background-color: #ffffffd9;
             height: auto;
             box-shadow: 0px 0px 10px 2px #969696;">
          <div *ngIf="secMostrar === 'RECUPERAR'">
            <div>
              <img class="logo-size" src="assets/images/logo-analizamos-color-completo.svg" alt="">
            </div>
            <h3 style="color: #333333">{{ 'AUTENTICACION.LBL_RECUPERARCONTRASENA' | translate }}</h3>
            <p style="color: #333333">{{ 'AUTENTICACION.MSG_RECUPERARCONTRASENA' | translate }}</p>
            <form name="forRecuperar" (ngSubmit)="frc.valid && recuperarContrasena(frc)" #frc="ngForm" novalidate>
              <input type="text" [(ngModel)]="objRecuperarContrasena.correo" autocomplete="off"
                     placeholder="* {{ 'AUTENTICACION.LBL_CORREO' | translate }}" required="true"
                     sinEspacios [sinCaracteres]="false" [minuscula]="false"
                     pattern="[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,3}$"
                     name="nomCorreo" id="idCorreo" #NGcorreo="ngModel"
                     style="margin-bottom: 0px; box-shadow: 0px 2px 3px 2px #c2c2c2;">
              <div *ngIf="frc.submitted && !NGcorreo.valid">
                <p *ngIf="NGcorreo.errors.required"
                   class="texto-rojo text-left">{{ 'AUTENTICACION.LBL_CORREO' | translate}}
                  {{'LBL_REQUERIDO' | translate }}</p>
                <p *ngIf="NGcorreo.errors.pattern"
                   class="texto-rojo text-left">{{ 'AUTENTICACION.LBL_CORREO' | translate}}
                  {{'MSG_FORMATOCORREO' | translate }}</p>
              </div>
              <div *ngIf="!recDatos">
                <div class="form-button text-center">
                  <button style="padding-left: 10px; padding-right: 10px;" id="btnRegresarRecuperar" type="button" class="ibtn btn-cancelar"
                          (click)="regresarRecuperar(frc)">{{
                    'BTN_CANCELAR' |
                      translate}}
                  </button>
                  <button style="padding-left: 10px; padding-right: 10px;" id="btnRecuperar" type="submit" class="ibtn btn-forget">{{ 'BTN_ACEPTAR' | translate}}
                  </button>
                </div>
              </div>
              <div *ngIf="recDatos" class="text-general">
                <i class="fa fa-refresh fa-spin fa-2x fa-fw"></i><br>
                <span>{{ 'LBL_PROCESANDO' | translate }}...</span>
              </div>
            </form>
          </div>
        </div>
        <div class="form-sent" [ngClass]="{'hide-it': secMostrar !== 'ENVIADO', 'show-it': secMostrar === 'ENVIADO' }"
              style="text-align: center;
              border: 1px solid #fff;
              padding: 35px 35px 14px;
              border-radius: 20px;
              background-color: #ffffffd9;
              height: auto;
              box-shadow: 0px 0px 10px 2px #969696;">
          <div *ngIf="secMostrar === 'ENVIADO'">
            <div>
              <img class="logo-size" src="assets/images/logo_login.png" alt=""
                   style="margin-top: -66px;margin-bottom: 34px;">
            </div>
            <p class="text-msg" style="color: black">{{resRecuperacion.respuesta}}</p>
            <div style="font-size: 18px; font-weight: 700; color: black; border-top: 1px solid rgba(255, 255, 255, 0.5);
                  padding: 1px; margin-top: 60px;">
              <span><a (click)="inicio()">{{'AUTENTICACION.LBL_IRINICIO' | translate}}</a></span>
            </div>
          </div>
        </div>
      </div>
      <div *ngIf="secMostrar === 'ACTUALIZAR'">
        <app-recuperacion-datos [seccionActualizar]="true" [tokenActualizar]="token" (cargarLogin)="cambiarSeccion($event)">
        </app-recuperacion-datos>
      </div>
    </div>
  </div>
</div>

<p-confirmDialog icon="fa fa-question-circle" header="{{ 'LBL_CONFIRMACION' | translate }}" #cd>
  <p-footer>
    <button type="button" pButton icon="pi pi-times" label="{{ 'LBL_NO' | translate }}" (click)="cd.reject()"></button>
    <button type="button" pButton icon="pi pi-check" label="{{ 'LBL_SI' | translate }}" (click)="cd.accept()"></button>
  </p-footer>
</p-confirmDialog>


<p-dialog header="{{ 'AUTENTICACION.LBL_CONFIRMACIONVALIDACION' | translate }}"
          [draggable]="false"
          [resizable]="false"
          [closable]="false"
          [modal]="true"
          [(visible)]="verDobleValidacion"
          (onShow)="authOnShow()"
>
  <div *ngIf="secQR">
    <div class="grid">
      <div class="col-12 md:col-12 lg:col-12 text-center">
        <p>{{ 'AUTENTICACION.MSG_CODIGOQR' | translate }}</p>
        <div [innerHTML]="qrCode | safeHtml"></div>
      </div>
    </div>

    <div class="grid form-footer-buttons">
      <div class="col-12 md:col-12 lg:col-12">
        <button icon="fa fa-check-circle-o" label="{{'BTN_CONFIRMAR' | translate }}"
                (click)="confirmarQR()"
                type="button"
                pButton></button>
      </div>
    </div>
  </div>
  <div *ngIf="!secQR">
    <div class="grid">
      <div class="col-12 text-center">
        <p>{{ 'AUTENTICACION.MSG_CODIGOGOOGLEAUTH' | translate }}</p>
      </div>
    </div>

    <form #fg="ngForm" (ngSubmit)="fg.valid && validarCodigo()" novalidate>
      <div class="grid form-group">
        <div class="col-12 md:col-12 lg:col-12">
          <div class="div-form">
            <label>* {{ 'AUTENTICACION.LBL_CODIGOVALIDACION' | translate }}</label>
            <input type="text" pInputText id="valCodigo"
                   name="valCodigo"
                   [(ngModel)]="codIngreso"
                   #NGvalidarCodigo="ngModel"
                   [maxlength]="10"
                   numeroEntero
                   required
                   autofocus
                   autocomplete="off"
            >
            <div class="p-message p-messages-error p-corner-all" *ngIf="fg.submitted && !NGvalidarCodigo.valid">
              {{"AUTENTICACION.LBL_CODIGOVALIDACION" | translate}}
            </div>
            <div class="p-message p-messages-error p-corner-all" *ngIf="codInvalido">
              {{"AUTENTICACION.LBL_CODIGOINVALIDO" | translate}}
            </div>
          </div>
        </div>
      </div>
      <div class="grid form-footer-buttons">
        <div class="form-group col-12">
          <div *ngIf="!validando">
            <button icon="fa fa-check-square" label="{{'BTN_VALIDAR' | translate }}"
                    type="submit"
                    pButton></button>
          </div>
          <div *ngIf="validando">
            <i class="fa fa-refresh fa-spin fa-2x fa-fw"></i><br>
            <span>{{'LBL_VALIDANDO' | translate }}</span>
          </div>
        </div>
      </div>
    </form>

  </div>

</p-dialog>
<p-confirmDialog #acep key="aceptarCambioContra" [closable]="false ">
  <p-footer>
    <button type="button" pButton icon="fa fa-check" label="Aceptar" (click)="acep.accept()"></button>
    <button type="button" pButton icon="fa fa-close" label="Cancelar" (click)="acep.reject()"></button>
  </p-footer>
</p-confirmDialog>
